import { Component, OnDestroy, OnInit, PipeTransform, ViewChild } from '@angular/core';
import { UnauthorizedCabinetAccessService } from "../services/unauthorized-cabinet-access.service"
import { SortInfo } from "../../core/models/sort.mode";
import { FeatureSet } from "../../core/statistics-page-menu/statistics-page-menu.component";
import { Page } from "../../core/models/page.model";
import { DatePipe } from "@angular/common";

@Component({
  selector: 'cintas-unauthorized-cabinet-access-summary',
  templateUrl: './unauthorized-cabinet-access-summary.component.html',
  styleUrls: ['./unauthorized-cabinet-access-summary.component.scss']
})
export class UnauthorizedCabinetAccessSummaryComponent implements OnInit {

  features = [];

  rows = [];
  page = { totalElements: 0, pageNumber: 0, size: 10 };
  dataLoading = false;
  exportLoading = false;
  exportDetailsLoading = false;

  columns = [
    { name: 'cuid', prop: 'cuid' },
    { name: 'Product', prop: 'product.name' },
    { name: 'User name', prop: 'cabinet_user.full_name' },
    { name: 'User email', prop: 'cabinet_user.email' },
    { name: 'User Tag ID', prop: 'cabinet_user.tag_id' },
    { name: 'Active tag ', prop: 'cabinet_user.active_tag' },
    { name: 'Created at', prop: 'created_at' },
  ];

  dataSub;

  constructor(private unauthorizedCabinetAccessService: UnauthorizedCabinetAccessService, private datePipe: DatePipe,) { }
  ngOnInit() {
    this.loadUsers()
  }

  loadUsers(): void {
    this.dataLoading = true;
    this.unauthorizedCabinetAccessService.getUnauthorizedCabinetAccessSummary().subscribe(data => {
      console.log("comp")
      console.log(data)
      this.rows = data.data;
      console.log("comp2")
      console.log(this.rows)
      this.dataLoading = false;
    });
  }

}
